import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import * as dayjs from 'dayjs';

import { ErrorService } from '@service/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private DATE_FORMAT: string = 'YYYY-MM-DD HH:mm';

  constructor(private errorService: ErrorService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError((error: Error) => {
        const timestamp: string = dayjs(new Date().getTime()).format(this.DATE_FORMAT);
        this.errorService.setTimestamp(timestamp);
        return throwError(error);
      })
    );
  }
}
